import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=3b9c7a8b&scoped=true&"
import script from "./PageError.vue?vue&type=script&lang=ts&"
export * from "./PageError.vue?vue&type=script&lang=ts&"
import style0 from "./PageError.vue?vue&type=style&index=0&id=3b9c7a8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c7a8b",
  null
  
)

export default component.exports